import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder';

/**
 * Renames the scaffolder task list to Events.
 *
 * The tab itself is renamed from app-config; this covers the copy inside the
 * page, which the sub-page extension config does not reach.
 */

const scaffolderTranslation = TranslationBlueprint.make({
  name: 'scaffolder',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderTranslationRef,
      messages: {
        'listTaskPage.content.tableTitle': 'Events',
      },
    }),
  },
});

export const scaffolderModule = createFrontendModule({
  pluginId: 'app',
  extensions: [scaffolderTranslation],
});
